var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 4.386c0-2.35 2.58-3.788 4.58-2.551l12.3 7.614c1.894 1.173 1.894 3.93 0 5.102l-12.3 7.615c-2 1.237-4.58-.2-4.58-2.551V4.385z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGc+CjxwYXRoIGQ9Ik0zLjcwMDIgNC4zODU2MkMzLjcwMDIgMi4wMzUwOSA2LjI4MDY5IDAuNTk3NjExIDguMjc5MjYgMS44MzQ4MkwyMC41Nzk3IDkuNDQ5MzdDMjIuNDc0MyAxMC42MjIyIDIyLjQ3NDMgMTMuMzc4MSAyMC41Nzk3IDE0LjU1MUw4LjI3OTI2IDIyLjE2NTVDNi4yODA2OSAyMy40MDI3IDMuNzAwMiAyMS45NjUyIDMuNzAwMiAxOS42MTQ3VjQuMzg1NjJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };